import { useLazyQuery, useMutation } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useSubmitOperation, {
  getMutationFunction,
  handleFormSubmission,
  usePrepareGraphQLVariables,
} from "../../../../CommonFunction/CustomUseFormSubmission";
import { replaceUnderscore } from "../../../../CommonFunction/common";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import {
  CREATE_ACCOUNT_GROUP,
  EDIT_ACCOUNT_GROUP,
  GET_ACCOUNT_GROUP_BYID,
  LOCK_ACCOUNT_GROUP,
  MERGE_ACCOUNT_GROUP,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import PortalFooter from "../../../Components/Reactportal/PortalFooter";
import Reactportal from "../../../Components/Reactportal/Reactportal";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import { Confirm } from "../../Confirmation/Confirm";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import { handleFormReset, updateSingleField, updateValueForm } from "../../FormInputSectionComponent/formUtils";
import { useModalContext } from "../../Reactportal/ModalContext";
import { ErrorToast } from "../../ToastComponent/RectHotToast";
import ".././FormComponent.scss";
import { AccountGroupConfig, AccountGroupConfigForMerge } from "./AddAccountGroup.config.js";
import "./AddAccountGroup.scss";
import useIsDisabled from "../../../custom_hooks/useIsDisabled";

const AddAccountGroup = ({ show, TypeOfPortal, submitType, ParentPortalCloseFunction }) => {
  const { pushModal, popModal } = useModalContext();
  const Form_Key = "Account_Group";
  const formRef = useRef({});
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const [isFirstLoad, setFirstLoad] = useState(false);

  const [field, setFields] = useState(TypeOfPortal === "Merge" ? AccountGroupConfigForMerge : AccountGroupConfig);
  const [ConfirmMerge, SetConfirmMerge] = useState(false);
  const [toggle, settoggle] = useState(show ? show : false);
  const [FormData, setFormdata] = useState({});

  const [GetAccountsGroupByID, { loading: GetAccountsGroupByIDLoader }] = useLazyQuery(GET_ACCOUNT_GROUP_BYID, {
    fetchPolicy: "network-only",
  });
  const fielddataRedux = useSelector((store) => store.UniqueTableReducer);
  const fielddata = fielddataRedux?.Account_Group?.Selected_Row;

  const [allFieldsData, setAllFieldsData] = useState({});
  const [MergingData, { loading: MergeAccountGroupLoading }] = useMutation(MERGE_ACCOUNT_GROUP);
  const [EditingData, { loading: editAccountingGroupLoading }] = useMutation(EDIT_ACCOUNT_GROUP);
  const [CreatingData, { loading: createAccountGroupLoading }] = useMutation(CREATE_ACCOUNT_GROUP);
  const [lockTheEntry, { loading: lockAccountGroupLoading }] = useMutation(LOCK_ACCOUNT_GROUP);
  const [selectedRows, setSelectedRows] = useState([]);
  const dispatch = useDispatch();
  const [formErrors, setFormErrors] = useState({});
  const [initialData, setInitialData] = useState({})
  const { isDisabled } = useIsDisabled({ TypeOfPortal, initial: initialData, current: FormData });


  const AccountGroupLoadingState =
    createAccountGroupLoading || editAccountingGroupLoading || MergeAccountGroupLoading || GetAccountsGroupByIDLoader;

  const HanldeChangeonForm = (values) => {
    setFormdata(prev => {
      const next = { ...prev, ...values };
      if (!isFirstLoad) {
        setInitialData(next)
      }
      return next
    })
  };


  useEffect(() => {
    if (toggle) {
      pushModal(Form_Key);
    }
  }, [toggle, Form_Key, pushModal]);

  useEffect(() => {
    const input = document.getElementsByName("Account_Group");
    if (input.length > 0) {
      input[input.length - 1].focus();
    }
  }, []);

  useEffect(() => {
    setSelectedRows(fielddataRedux?.[Form_Key]?.Selected_Rows);
  }, [fielddataRedux]);

  // Handle errors received from FormInputSectionComponent
  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };
  //to check errors and throw the error submit will not
  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (!Error) {
      submit();
    }
  };

  useEffect(() => {
    // Check if the portal type requires fetching data and if there's a valid ID to fetch.
    if (TypeOfPortal !== "Add" && TypeOfPortal !== "Delete" && fielddata && fielddata._id) {
      console.log(fielddata);
      GetAccountsGroupByID({
        variables: {
          id: fielddata._id,
        },
      }).then(({ data }) => {
        let GroupData = { ...data?.AccountGroup[0] };
        dispatch({
          type: "StoreMasterData",
          payload: {
            formkey: Form_Key,
            data: {
              Group_Under: GroupData?.Group_Under,
            },
          },
        });
        if (GroupData?.Group_Under) {
          GroupData.Group_Under = GroupData?.Group_Under?.Account_Group;
        }
        setAllFieldsData(GroupData);
        updateValueForm(formRef, GroupData);
      });
    } else {
      setAllFieldsData({});
    }
  }, [fielddata, TypeOfPortal, GetAccountsGroupByID, dispatch, Form_Key]);

  useEffect(() => {
    updateSingleField(formRef, "Report_Side", FormDataFromRedux?.MasterData[Form_Key]?.Group_Under?.Report_Side);
  }, [FormDataFromRedux?.MasterData[Form_Key]?.Group_Under?._id]);
  const { executeOperation } = useSubmitOperation();
  const operationType = TypeOfPortal;
  let formData = FormData;
  if (operationType === "Merge") {
    formData.existingId = fielddata._id;
    formData.newId = FormDataFromRedux?.MasterData[Form_Key]?.replace_with?._id;
  }
  const variables = usePrepareGraphQLVariables(operationType, allFieldsData, formData, selectedRows);
  // console.log(variables);
  const MutationFunctions = {
    CreatingData,
    EditingData,
    MergingData,
    lockTheEntry,
  };

  const submit = async (closeAction) => {
    formData.Group_Under = FormDataFromRedux?.MasterData[Form_Key]?.Group_Under?._id;
    console.log(formData);

    const mutationFunction = getMutationFunction(operationType, MutationFunctions);
    const executeOperationFunction = () =>
      executeOperation({
        operationType,
        data: formData,
        selectedRows,
        Mutation: () => mutationFunction({ variables }),

        processDataBeforeSubmit: (data) => data,
        PageName: Form_Key,
        OnSuccess: () => {
          handleFormReset(formRef);
        },
      });
    handleFormSubmission(executeOperationFunction, {
      dispatch,
      Form_Key,
      operationType,
      closeAction,
      closeFormFunction: Closeformfunction,
      resetFormDataFunction: () => {
        setAllFieldsData();
        handleFormReset(formRef);
      },
      onSuccess: () => { },
      onError: (error) => {
        ErrorToast(error.message);
      },
    });
  };

  const Closeformfunction = () => {
    popModal(Form_Key);
    ParentPortalCloseFunction();
    settoggle(false);
    setAllFieldsData({});
    ClearSpecificForm(dispatch, Form_Key);
  };

  const SaveAndCloseForAdd = () => {
    submit("Close");
  };

  const ConfirmModalOpen = () => {
    SetConfirmMerge(true);
  };

  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={isDisabled}
      submitform={() => Validate_handleSubmit(submit)}
      submitType={submitType}
      Form_key={Form_Key}
      SaveAndClose={
        TypeOfPortal === "Add"
          ? () => Validate_handleSubmit(SaveAndCloseForAdd)
          : TypeOfPortal === "Merge"
            ? () => ConfirmModalOpen()
            : () => Validate_handleSubmit(submit)
      }
      handleformclose={() => {
        Closeformfunction();
        settoggle(!toggle);
      }}
      loadingState={AccountGroupLoadingState}
    />
  );
  console.log(TypeOfPortal);
  if (TypeOfPortal === "Lock" || TypeOfPortal === "Unlock") {
    return (
      <>
        <Confirm
          submitType={`Confirm ${TypeOfPortal}`}
          submit={submit}
          settoggle={settoggle}
          toggle={toggle}
          loadingState={lockAccountGroupLoading}
          message={`Are You Sure You Want to ${TypeOfPortal} this Record?`}
        />
      </>
    );
  }
  const OptionsColumns = [
    { key: "Account_Group", label: "Account Group" },
    { key: "Unique_Id", label: "Unique ID" },
  ];
  return (
    <>
      <div>
        <Reactportal
          FoooterContent={footerContent}
          open={toggle}
          onClose={Closeformfunction}
          TypeOfPortal={TypeOfPortal + " Account Group"}
        >
          {AccountGroupLoadingState && <div className="loader-line-div" />}
          <div className="formContainer">
            {field &&
              field.map((e) => {
                return (
                  <div key={e.id} className="FormSectionParent">
                    <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                    <div className="FormSection insidecontainer">
                      <FormInputSectionComponent
                        handelformikdata=""
                        inputfields={e.fields}
                        Type={e.name}
                        fielddata={allFieldsData}
                        validation_Schema={e.Valid_schema}
                        onErrorsChange={(newErrors) => handleErrorsChange(newErrors)}
                        onhandleFormikChange={HanldeChangeonForm}
                        formkey={Form_Key}
                        OptionsColumns={OptionsColumns}
                        formRef={formRef}
                        setFirstLoad={setFirstLoad}
                      />
                    </div>
                  </div>
                );
              })}
          </div>
        </Reactportal>
      </div>
      {ConfirmMerge && (
        <Confirm
          submit={submit}
          settoggle={SetConfirmMerge}
          toggle={ConfirmMerge}
          loadingState={AccountGroupLoadingState}
          submitType={"Confirm Merge"}
          TypeOfPortal={"Confirm"}
          message={`Are you sure you want to merge this Record?`}
        />
      )}
    </>
  );
};

export default AddAccountGroup;
